module.exports = __webpack_public_path__ + "c26263b58365c70386c32d77feea6c3f.fbx";